export const LSNHAPKHO_LIST_INITING         = 'LSNHAPKHO_LIST_INITING'

export const LSNHAPKHO_LIST_NCC_REQUESTING      = 'LSNHAPKHO_LIST_NCC_REQUESTING'
export const LSNHAPKHO_LIST_NCC_SUCCESS         = 'LSNHAPKHO_LIST_NCC_SUCCESS'
export const LSNHAPKHO_LIST_NCC_ERROR           = 'LSNHAPKHO_LIST_NCC_ERROR'   

export const LSNHAPKHO_LIST_KHO_REQUESTING      = 'LSNHAPKHO_LIST_KHO_REQUESTING'
export const LSNHAPKHO_LIST_KHO_SUCCESS         = 'LSNHAPKHO_LIST_KHO_SUCCESS'
export const LSNHAPKHO_LIST_KHO_ERROR           = 'LSNHAPKHO_LIST_KHO_ERROR'


export const LSNHAPKHO_LIST_REQUESTING      = 'LSNHAPKHO_LIST_REQUESTING'
export const LSNHAPKHO_LIST_SUCCESS         = 'LSNHAPKHO_LIST_SUCCESS'
export const LSNHAPKHO_LIST_ERROR           = 'LSNHAPKHO_LIST_ERROR'   

export const LSNHAPKHO_ITEM_REQUESTING      = 'LSNHAPKHO_ITEM_REQUESTING'
export const LSNHAPKHO_ITEM_SUCCESS         = 'LSNHAPKHO_ITEM_SUCCESS'
export const LSNHAPKHO_ITEM_ERROR           = 'LSNHAPKHO_ITEM_ERROR'   

export const LSNHAPKHO_PRINT_REQUESTING     = 'LSNHAPKHO_PRINT_REQUESTING'
export const LSNHAPKHO_PRINT_SUCCESS        = 'LSNHAPKHO_PRINT_SUCCESS'
export const LSNHAPKHO_PRINT_ERROR          = 'LSNHAPKHO_PRINT_ERROR'   

export const LSNHAPKHO_EXPORT_XLS_INITING         = 'LSNHAPKHO_EXPORT_XLS_INITING'
export const LSNHAPKHO_EXPORT_XLS_REQUESTING      = 'LSNHAPKHO_EXPORT_XLS_REQUESTING'
export const LSNHAPKHO_EXPORT_XLS_SUCCESS         = 'LSNHAPKHO_EXPORT_XLS_SUCCESS'
export const LSNHAPKHO_EXPORT_XLS_ERROR           = 'LSNHAPKHO_EXPORT_XLS_ERROR'

export const LSNHAPKHO_LIST_NCC_API         = '/api/v1/management/nhacc_list_by_store'
export const LSNHAPKHO_LIST_KHO_API         = '/api/v1/management/kho_cap_list_by_store_user'   
export const LSNHAPKHO_LIST_API             = '/api/v1/import/find_lsnhapkho'  
export const LSNHAPKHO_EXPORT_API           = '/api/v1/import/lsnhapkho_export_by_store'  
export const LSNHAPKHO_ITEM_API             = '/api/v1/admin/user_details' 
export const LSNHAPKHO_PRINT_API            = '/api/v1/import/export_nhap' 


// WEBPACK FOOTER //
// ./src/views/LsNhapKho/constants.js